import {
  IntegrationCard,
  IntegrationStatusTypes,
} from "../types/integration-card";

export const mockIntegrationCards: IntegrationCard[] = [
  {
    id: "card-1",
    status: IntegrationStatusTypes.NOT_CONNECTED,
    selectedOrgan: {
      id: "moscow-gsn",
      name: "Московский Государственный Строительный Надзор",
    },
    buildBusEnabled: true,
    attributes: {
      connectionId: "32498723-WEF",
      version: "13.0",
      connectionPath: "https://12345.com",
    },
  },
  {
    id: "card-2",
    status: IntegrationStatusTypes.CONNECTED,
    selectedOrgan: {
      id: "amur-gsn",
      name: "Амурокомсомольский федеральный округ имени И. И. Ленина Государственный Строительный Надзор",
    },
    buildBusEnabled: true,
    attributes: {
      connectionId: "32498723-WEF",
      version: "13.0",
      connectionPath: "https://12345.com",
    },
    actionHistory: [
      {
        id: "history-1",
        dateTime: "27.03.2024 12:30 GMT+3",
        user: "Застроев Г. А.",
        position: "Начальник",
        status: "Подключена",
        organName: "Санкт-Петербургский Строительный Надзор",
      },
      {
        id: "history-2",
        dateTime: "27.03.2024 12:30 GMT+3",
        user: "Застроев Г. А.",
        position: "Начальник",
        status: "Отключена",
        organName: "Московский Государственный Строительный Надзор",
      },
      {
        id: "history-3",
        dateTime: "27.12.2023 12:30 GMT+3",
        user: "Застроев Г. А.",
        position: "Начальник",
        status: "Подключена",
        organName: "Московский Государственный Строительный Надзор",
      },
    ],
    lastAction: {
      user: "Сергей Иванович Семёнов",
      date: "26.08.2025",
      time: "14:00 МСК",
    },
  },
  {
    id: "card-3",
    status: IntegrationStatusTypes.DISCONNECTED,
    selectedOrgan: {
      id: "moscow-gsn",
      name: "Московский Государственный Строительный Надзор",
    },
    actionHistory: [
      {
        id: "history-4",
        dateTime: "27.03.2024 12:30 GMT+3",
        user: "Застроев Г. А.",
        position: "Начальник",
        status: "Отключена",
        organName: "Московский Государственный Строительный Надзор",
      },
      {
        id: "history-5",
        dateTime: "27.12.2023 12:30 GMT+3",
        user: "Застроев Г. А.",
        position: "Начальник",
        status: "Подключена",
        organName: "Московский Государственный Строительный Надзор",
      },
    ],
  },
];

export const supervisionOrgans = [
  {
    id: "moscow-gsn",
    name: "Московский Государственный Строительный Надзор",
  },
  {
    id: "spb-gsn",
    name: "Санкт-Петербургский Строительный Надзор",
  },
  {
    id: "amur-gsn",
    name: "Амурокомсомольский федеральный округ имени И. И. Ленина Государственный Строительный Надзор",
  },
  { id: "gkh-spb", name: "ГКХ СПб" },
  { id: "rostekhnadzor", name: "Ростехнадзор" },
];

